import React from "react";
import { Link } from "react-router-dom";
import educationData from "../data/education";

const Education = () => {
  const handleToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center mb-7 underline font-serif text-3xl font-bold text-purple-700">
          Education:
        </h1>
        {[
          educationData.pgdm,
          educationData.btech,
          educationData.hs,
          educationData.secondary,
        ].map((section) => (
          <div className="pt-6" key={section.title}>
            <div className="sm:text-lg">
              <div className="flex bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
                <div className="pr-2">
                  <i className="fa-solid fa-arrows-to-dot"></i>
                </div>
                <div className="font-bold text-xl">{section.title}</div>
              </div>
              <div className="">
                <div className="my-2 sm:pl-4 space-x-7">
                  <ul className="space-y-2">
                    <div className="sm:flex sm:space-x-4">
                      <li>
                        <i className="fa-solid fa-circle mr-2 text-xs"></i>
                        <span className="font-semibold">
                          Name of Institution:
                        </span>
                      </li>
                      <li>{section.institution}</li>
                    </div>
                    {section.university && (
                      <div className="sm:flex sm:space-x-4">
                        <li>
                          <i className="fa-solid fa-circle mr-2 text-xs"></i>
                          <span className="font-semibold">
                            Name of University:
                          </span>
                        </li>
                        <li>{section.university}</li>
                      </div>
                    )}
                    {section.board && (
                      <div className="sm:flex sm:space-x-4">
                        <li>
                          <i className="fa-solid fa-circle mr-2 text-xs"></i>
                          <span className="font-semibold">Name of Board:</span>
                        </li>
                        <li>{section.board}</li>
                      </div>
                    )}
                    {section.cgpa && (
                      <div className="sm:flex sm:space-x-4">
                        <li>
                          <i className="fa-solid fa-circle mr-2 text-xs"></i>
                          <span className="font-semibold">CGPA:</span>
                        </li>
                        <li>{section.cgpa}</li>
                      </div>
                    )}
                    {section.percentage && (
                      <div className="sm:flex sm:space-x-4">
                        <li>
                          <i className="fa-solid fa-circle mr-2 text-xs"></i>
                          <span className="font-semibold">Percentage:</span>
                        </li>
                        <li>{section.percentage}</li>
                      </div>
                    )}
                    {section.sgpa && (
                      <div className="pl-6">
                        {section.sgpa.map((s) => (
                          <div className="sm:flex sm:space-x-4" key={s.label}>
                            <li>
                              <i className="fa-regular fa-circle mr-2 text-xs"></i>
                              <span className="font-semibold">{s.label}:</span>
                            </li>
                            <li>{s.value}</li>
                          </div>
                        ))}
                      </div>
                    )}
                    {section.referencePath && (
                      <div className="sm:flex sm:space-x-4">
                        <li>
                          <i className="fa-solid fa-circle mr-2 text-xs"></i>
                          <span className="font-semibold">Reference:</span>
                        </li>
                        <Link
                          className="text-blue-600 underline font-semibold hover:text-purple-700 dark:hover:text-purple-600 hover:font-semibold"
                          to={section?.referencePath}
                          onClick={handleToTop}
                        >
                          Click Here
                        </Link>
                      </div>
                    )}
                    {(section?.session || section?.year) && (
                      <div className="sm:flex sm:space-x-4">
                        <li>
                          <i className="fa-solid fa-circle mr-2 text-xs"></i>
                          <span className="font-semibold">
                            {section.session
                              ? "Session:"
                              : "Year of Completion:"}
                          </span>
                        </li>
                        <li>{section.session || section.year}</li>
                      </div>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;
